import { Form, Checkbox, Link, Button, Space, Message, Input } from "@arco-design/web-react";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import logoradioa from "@/assets/iconimage/radioa.png";
import logoradiob from "@/assets/iconimage/radiob.png";
import eye_open from "@/assets/iconimage/eye_open.png";
import CryptoJS from "crypto-js";
import eye_close from "@/assets/iconimage/eye_close.png";
import "./style/style.less";
const FormItem = Form.Item;
import { observer, inject } from "mobx-react";
import Cookies from "js-cookie";
import { SecureStringGenerator } from "@/utils";
import appStore from "@/stores/appStore";

const Accountlogin = (props: any) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const formref = useRef(form);
  const [radioopp, setradioopp] = useState(0);
  const [loading, setLoading] = useState(false);
  const [checkdata, setcheckdata] = useState(false);
  const { login } = props;
  const location = useLocation();
  const [urlstate, setstate] = useState(null);
  const [passVisibility, setPassVisibility] = useState<boolean>(false);

  useEffect(() => {
    try {
      const code = location.search.split("=")[1];
      setstate(code);
    } catch (e) {}
  }, [location]);

  function validatePassword(value, callback) {
    if (!value) {
      callback(<div>密码不能为空</div>);
    } else if (!/^.{6,}$/.test(value)) {
      callback(<div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>);
    } else {
      callback();
    }
  }
  useEffect(() => {
    if (Cookies.get("Logindata")) {
      const encryptedData = Cookies.get("Logindata");

      try {
        // 解密数据
        const bytes = CryptoJS.AES.decrypt(encryptedData, SecureStringGenerator.generate(16));

        // 将解密后的字节转换为 UTF-8 字符串
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // 检查解密后的数据是否是有效的 UTF-8 字符串
        if (decrypted) {
          try {
            // 解析解密后的 JSON 字符串
            const data = JSON.parse(decrypted);
            const { phone_number, password } = data;

            // 设置表单字段值
            formref?.current.setFieldValue("phone_number", phone_number);
            formref?.current.setFieldValue("password", password);

            // 设置 checkdata 为 true
            setcheckdata(true);
          } catch (error) {
            console.error("解析解密后的数据时出错:", error);
          }
        } else {
          console.error("解密后的数据不是有效的 UTF-8 字符串。");
        }
      } catch (error) {
        console.error("解密数据时出错:", error);
      }
    }
  }, []);

  async function onSubmitClick(datalist) {
    // 是odm贴牌的话，不需要协议
    // if (!radioopp && !appStore.isOdm) {
    //   Message.info("请勾选用户协议");
    // } else {
    //
    // }
    setLoading(true);
    await login.Accc_use_login(datalist);
    setLoading(false);
  }

  useEffect(() => {
    if (login.isSuccess) {
      if (checkdata) {
        const password = formref.current.getFieldValue("password");
        const phone_number = formref.current.getFieldValue("phone_number");
        const data = {
          phone_number: phone_number,
          password: password,
        };
        Cookies.set(
          "Logindata",
          CryptoJS.AES.encrypt(JSON.stringify(data), SecureStringGenerator.generate(16)).toString(),
          {
            expires: 7,
          }
        );
      } else {
        Cookies.remove("Logindata");
      }
      setTimeout(() => {
        const searchParams = new URLSearchParams(location.search);
        const next = searchParams.get("next") || "/";
        navigate(next, { replace: true });
        login.isSuccess = false;
      }, 600);
    }
  }, [login.isSuccess]);

  const validatePhoneNumber = (value, callback) => {
    if (!value) {
      callback(<div>请输入正确的用户名</div>);
    } else {
      callback();
    }
  };

  return (
    <div>
      <Form ref={formref} autoComplete="off" className="form-cottop">
        <FormItem field="phone_number" rules={[{ validator: validatePhoneNumber, validateTrigger: "onBlur" }]}>
          <Input
            style={{ fontSize: "16px" }}
            className="form-contorinput"
            autoComplete="username"
            allowClear={true}
            placeholder="请输入账号"
          />
        </FormItem>
        <FormItem field="password" rules={[{ validator: validatePassword, validateTrigger: ["onBlur"] }]}>
          <Input.Password
            defaultValue="password"
            autoComplete="current-password"
            placeholder="请输入密码"
            visibility={passVisibility}
            onVisibilityChange={setPassVisibility}
            suffix={<img src={passVisibility ? eye_open : eye_close} style={{ cursor: "pointer" }} width={12} />}
          />
        </FormItem>
        <Space direction="vertical">
          <div id="login-actions">
            <Checkbox
              checked={checkdata}
              onChange={() => {
                setcheckdata(!checkdata);
              }}
            >
              记住密码
            </Checkbox>
          </div>
          <Button
            type="primary"
            long
            loading={loading}
            onClick={async () => {
              if (formref.current) {
                try {
                  await formref.current.validate();
                  const password = formref.current.getFieldValue("password");
                  const phone_number = formref.current.getFieldValue("phone_number");
                  onSubmitClick({ phone_number, password });
                } catch (_) {
                }
              }
            }}
            className="styleInputbutton"
          >
            登录
          </Button>
        </Space>
      </Form>
    </div>
  );
};
export default inject("login")(observer(Accountlogin));
